module.exports = __webpack_public_path__ + "china.svg?7f8455b70734a87596991e1f24053edc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/china.svg
// module id = 135
// module chunks = 10